import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './assets/main.css'
import App from './App.vue'
import { mobileViewportManager } from './utils/mobile-viewport'
import { config } from './utils/config'

// Initialize mobile viewport management
console.log('[Orbitar Chat] Initializing mobile viewport manager...');
const viewportInfo = mobileViewportManager.getViewportInfo();
console.log('[Orbitar Chat] Viewport Info:', viewportInfo);

// Listen for viewport changes and log them (helpful for debugging)
mobileViewportManager.onViewportChange(() => {
  const info = mobileViewportManager.getViewportInfo();
  console.log('[Orbitar Chat] Viewport changed:', {
    bottomBarHeight: info.bottomBarHeight,
    safeAreaBottom: info.safeAreaBottom,
    recommendedPadding: mobileViewportManager.getRecommendedBottomPadding()
  });
});

// Get widget configuration from URL params
const urlParams = new URLSearchParams(window.location.search);
const widgetId = urlParams.get('widgetId') || import.meta.env.VITE_WIDGET_ID || 'default';

// Log the widget ID for debugging
console.log('[Orbitar Chat] Using widget ID:', widgetId);

// Create and mount chat app
const app = createApp(App, {
  widgetId: widgetId,
  apiUrl: config.apiUrl,
  theme: {
    primaryColor: '#7986CB',
    accentColor: '#81D4FA',
    backgroundColor: '#F0FAFB'
  }
});

// Use Pinia for state management
app.use(createPinia());

// Mount when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  app.mount('#app');
});

// Export for API access
export { app }; 